<template>
  <div class="allmap" style="border-radius: 5px">
    <div class="search-div flexC">
      <div class="search-div-item flexC">
        <div class="labelText">{{ $t("deviceManage.titleName.Type") }}</div>
        <Select :placeholder="$t('selectPlaceholder')" clearable class="input-div" v-model="searchObj.productTypeId">
          <Option v-for="(item, index) in productsManageList" :value="item.id" :key="index">{{ item.productType }}
          </Option>
        </Select>
      </div>

      <div class="search-div-item flexC">
        <div class="labelText">{{ $t("deviceManage.whetherOnline") }}</div>
        <Select :placeholder="$t('selectPlaceholder')" clearable class="input-div" v-model="searchObj.whetherOnline">
          <Option v-for="(item, index) in searchObjArr.onlineType" :value="item.id" :key="index">{{ item["val"] }}
          </Option>
        </Select>
      </div>

      <div class="search-div-item">
        <Button type="info" @click="searchData" icon="ios-search" style="
            margin-top: 5px;
            height: 44px;
            line-height: 44px;
            width: 96px;
            border-radius: 10px;
          ">{{ $t("search") }}</Button>
      </div>
    </div>
    <!-- 图例 -->
    <div class="legendCon flexBC">
      <div class="flexC">
        <div class="title">{{ $t("legend") }}:</div>
        <div class="type type1 flexC">
          <img src="@/static/images/xinxi0.png" alt="" srcset="" />
          <div class="desc">{{ $t("selectList.onlineType.Online") }}</div>
        </div>
        <div class="type  type1 flexC">
          <img src="@/static/images/xinxi1.png" alt="" srcset="" />
          <div class="desc">{{ $t("selectList.onlineType.Outline") }}</div>
        </div>
        <div class="type flexC">
          <img src="@/static/images/xinxi.png" alt="" srcset="" />
          <div class="desc">{{ $t("All") }}</div>
        </div>
      </div>

      <div class="flexC">
        <div class="title">{{ $t("deviceLocation.map") }}:</div>
        <RadioGroup v-model="mapType" @on-change="changeType">
          <Radio label="baidu">
            <span>{{ $t("deviceLocation.baidu") }}</span>
          </Radio>
          <Radio label="google">
            <span>{{ $t("deviceLocation.google") }}</span>
          </Radio>
        </RadioGroup>
      </div>

    </div>

    <div v-if="mapType == 'google'" class="legendCon flexC" style="margin-top:20px ;">
      <div class="centerTitle" style="flex-shrink:0 ;">Map center point:</div>
      <div style="width:200px">
        <Select filterable clearable v-model="centerCountry" @on-change="changeCenter" >
          <Option v-for="item in countryList" :value="item.two_letter_code" :key="item.two_letter_code">{{ item.en_name+' '}}{{ item.cn_name}}</Option>
        </Select>
      </div>
    </div>

    <div v-if="mapType == 'baidu'" class="legendCon flexC" style="margin-top:20px ;">
      <div class="centerTitle" style="flex-shrink:0 ;">区域:</div>
      <div style="width:200px">
        <Select filterable clearable v-model="areaZoom" @on-select="selectZoom">
          <Option v-for="item in areaList" :value="item.zoom" :key="item.zoom">{{ item.name}}</Option>
        </Select>
      </div>
    </div>
    



    <google-map v-if="mapType == 'google'" ref="google" :searchObj="searchObj" :local="local" :centerGeo="centerGeo"></google-map>

    <baidu-map v-else-if="mapType == 'baidu'" ref="baidu" :local="local" :searchObj="searchObj" :areaZoom="areaZoom" @getZoom="getZoom"></baidu-map>

  </div>
</template>
<script>
import common from "@/common/common.js";
import googleMap from "./component/googleMapId.vue";
import baiduMap from "./component/mapv.vue";
import { mapState } from "vuex";
import { countryList as countryListJson } from './component/json/countryList'
export default {
  components: {
    googleMap,
    baiduMap,
  },
  data() {
    return {
      loading: true,
      productsManageList: [],
      searchObj: {
        status: '', //已激活
        productTypeId: "",
        whetherOnline: "",
      },
      mapType: 'baidu',
      centerCountry:'US',
      countryList:countryListJson,
      centerGeo:{
          lng:-95.7129,
          lat:37.0902,
          two_letter_code:'US'
      },
      areaZoom:5,
      areaList:[
        {
          zoom:5,
          name:'省'
        },
        {
          zoom:8,
          name:'城市'
        },
        {
          zoom:9,
          name:'区县其他'
        }
      ],
      areaQuery:true
    };
  },
  computed: {
    ...mapState(["local", "selectId"]),
    searchObjArr() {
      return {
        //    productsManageList:[],
        onlineType: [
          { id: "1", val: this.$t("selectList.onlineType.Online") },
          { id: "0", val: this.$t("selectList.onlineType.Outline") },
        ],
      };
    },
  },
  // watch: {
  //   local(newval) {
  //     window.location.reload();
  //   },
  // },
  methods: {
    getCenter(){//从本地获取中心点国家
      let centerGeoObj =  localStorage.getItem('centerGeo');
      console.log('centerGeoObj',centerGeoObj)
      if(centerGeoObj && centerGeoObj!='null'){
        this.centerCountry = (JSON.parse(centerGeoObj)).two_letter_code;
        this.centerGeo = {...JSON.parse(centerGeoObj)}
      }
    },
    changeCenter(value) {//存储中心点国家
      for(let i=0;i< this.countryList.length;i++){
        if(this.countryList[i].two_letter_code==value){
           this.centerGeo = {
            lng:this.countryList[i].lng,
            lat:this.countryList[i].lat,
            two_letter_code:this.countryList[i].two_letter_code
           }

           localStorage.setItem('centerGeo',JSON.stringify(this.centerGeo) )

           break
        }
      }
    
    },
    getType(){//从本地获取地图类型
      let type =  localStorage.getItem('mapType');
      if(type == 'google' || type == 'baidu'){
        this.mapType = type
      }
    },
    changeType(value){//存储地图类型
      this.searchObj =  {
        status: '',
        productTypeId: "",
        whetherOnline: "",
      },
      localStorage.setItem('mapType',value )
    },
    selectZoom(value){
     if(this.areaQuery == false){
       this.$refs.baidu.changeMapZoom(this.areaZoom);
     }
    },
    getZoom(value){
      if(value != this.areaZoom){
         this.areaQuery = false
      }else{
        this.areaQuery = true
      }
    },
    getSelect() {//获取下拉数据
      this.axios.post(this.config.urlArray.productsManageList, { dealerId: this.selectId, page: 1, limit: 10000 }).then((result) => {
        let resData = result.data.data.productList
        this.productsManageList = resData
      }).catch((err) => {
        // common.msg('error','获取失败',()=>{})
      });
    },
    searchData() {//搜索
      this.$refs[this.mapType].searchData();

      // switch (this.mapType) {
      //   case 'baidu':
      //     this.$refs.baidu.searchData();
      //     break
      //   case 'google':
      //     this.$refs.google.searchData();
      //     break
      // }
    },
  },
  created() {
    this.getCenter();
    this.getType();
    this.getSelect();
    console.log('process.env.BASE_URL',window.location.hostname)
  },
  mounted() { },
};
</script>
<style lang="less" scoped>
.search-div {
  flex-wrap: wrap;
  background-color: #fff;
  padding: 34px 40px;
  background: #ffffff;
  margin: 40px 40px 20px;
  border-radius: 14px;

  .search-div-item {
    margin-right: 20px;

    span {
      margin-right: 30px;
    }
  }

  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 44px;
    line-height: 44px;
  }

  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 44px;
    line-height: 44px;
  }

  /deep/ .ivu-select-single .ivu-select-selection {
    height: 44px;
    width: 200px;
  }

  /deep/ .ivu-input {
    height: 44px;
    line-height: 44px;
  }

  /deep/ .ivu-input-icon {
    height: 44px;
    line-height: 44px;
  }
}

.labelText {
  line-height: 54px;
  height: 54px;
  flex-shrink: 0;
  margin-right: 10px;
}

.legendCon {
  margin-left: 60px;
  margin-right: 60px;

  .title {
    font-weight: bold;
    margin-right: 10px;
  }

  .type1 {
    margin-right: 10px;
  }

  img {
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
}

.centerTitle{
  flex-shrink: 0;
  margin-right: 10px;
  height: 32px;
  line-height: 32px;
}
</style>